import { createAction } from '../../../../../store.model';
import {
    WpDisplayConfig,
    WpViewHeader,
} from '../../../winning-percentage/core';
import { ActionType } from '../../main.action';

export interface Reload {
    userId: number;
    dataRangeId?: number;
    evalRangeId?: number;
    drillPathId?: string;
    reset?: boolean;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.WP_MAIN__RELOAD,
);

export interface ReloadResult extends Reload {
    config?: WpDisplayConfig;
    header?: WpViewHeader;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.WP_MAIN__RELOAD_RESULT,
);
